import api from './index'
import { axios } from '@/utils/request'

export function createExpression(parameter) {
  return axios({
    url: api.BaseURL + api.Expression + 'create',
    method: 'POST',
    data: parameter
  })
}

export function getListExpression(parameter) {
  return axios({
    url: api.BaseURL + api.Expression + 'list',
    method: 'GET',
    params: parameter
  })
}

export function getDetailExpression(parameter) {
  return axios({
    url: api.BaseURL + api.Expression + 'detail',
    method: 'GET',
    params: parameter
  })
}

export function updateExpression(parameter) {
  return axios({
    url: api.BaseURL + api.Expression + 'update',
    method: 'POST',
    data: parameter
  })
}

export function deleteExpression(parameter) {
  return axios({
    url: api.BaseURL + api.Expression + 'delete',
    method: 'POST',
    data: parameter
  })
}